// Handrolled url's etc. in order to keep (this separate bundles) bundlesize to minimum
import { getCultureSettings } from '@/project/content/api/contentApi';

// Prefetch dictionary
getCultureSettings().then(settings => {
    addPrefetchLink(getLabelApiLink(settings.culture));
});

function getLabelApiLink(culture: string): string {
    const cmsHost = window.appData.cmsHost;
    const dictionaryKey = window.appData.dictionaryKey;
    return `${cmsHost}/dictionary?xhr=1&culture=${culture}&dictionaryKey=${dictionaryKey}`;
}

function addPrefetchLink(href: string): void {
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.as = 'json';
    link.crossOrigin = 'anonymous';
    head.appendChild(link);
}

// Because we run isolated modules (because of esbuild)
export {};
